var map = {
	"./1.jpg": 8171,
	"./2.jpg": 7548,
	"./3.jpg": 2809,
	"./4.jpg": 6346,
	"./4.png": 7022,
	"./5.jpg": 7511,
	"./5.png": 5335,
	"./6.jpg": 6584,
	"./6.png": 5276,
	"./7.jpg": 549,
	"./7.png": 4373,
	"./Gemini_Generated_Image_2uctab2uctab2uct.jpg": 2504,
	"./answerwriting.png": 1512,
	"./author.jpg": 9189,
	"./author.png": 8213,
	"./author2.jpg": 2075,
	"./author2.png": 4771,
	"./author3.jpg": 6238,
	"./author3.png": 4010,
	"./author4.jpg": 9653,
	"./author4.png": 8677,
	"./author5.jpg": 8472,
	"./author5.png": 1164,
	"./banner.png": 9722,
	"./banner2.jpg": 6726,
	"./banner2.png": 4738,
	"./banner3.png": 8395,
	"./banner4.png": 2756,
	"./banner5.png": 3885,
	"./current2.png": 5759,
	"./essay.png": 6531,
	"./expert.png": 1492,
	"./interview.png": 7323,
	"./link.png": 5916,
	"./logo-box.png": 5121,
	"./myth.png": 1394,
	"./optional.png": 4444,
	"./post-banner1.jpg": 2246,
	"./post-banner2.jpg": 17,
	"./post-banner3.jpg": 6292,
	"./qu.png": 1830,
	"./scheme.png": 737,
	"./timemanage.jpg": 1810,
	"./understanding.png": 5872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4346;